import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

/*** Components ***/
import PlanArea from "./PlanArea/PlanArea";
import OptionsArea from "./OptionsArea/OptionsArea";
import { VerticalArrows } from "../../../components/buildcomponent/VerticalArrows/VerticalArrows";
import { HorizontalArrows } from "../../../components/buildcomponent/HorizontalArrows/HorizontalArrows";

/*** actions ***/
import { pushBuildValueSides } from "../../../actions/pushBuildValuesSides";
import { pushBuildValue } from "../../../actions/pushBuildValue";
import { addLid } from "../../../actions/addLid";
import { duplicateSide } from "../../../actions/duplicateSide";
import { deleteLid } from "../../../actions/deleteLid";
import { deleteFromPlan } from "../../../actions/deleteFromPlan";

/*** styles ***/
import "./style.css";
import "../../../css/BuildSteps/overview.css";

/*** helpers ***/
import { isAllowLids } from "../../../helpers/isAllowLids";
import { isAllowSleeve } from "../../../helpers/isAllowSleeves";
import {SIZE_OF_CELL} from "../../../constants/constants";
import { shiftSleevesAndLids } from "../../../helpers/shiftSleevesAndLids";

class BuildStep extends Component {
  constructor(props) {
    super(props);
    this.state = {
      innerAreaSizeOneCell: null,
      horizontalNumberOfCells: 15,
      verticalNumberOfCells: 5,
      position: []
    };
  }
  componentDidMount() {
    const innerArea = document.body.getElementsByClassName("inner-plan-step-2"),
          step = +this.props.match.params.step,
          innerAreaWidth = innerArea[0].clientWidth,
          horizontalNumberOfCells = this.props.buildValues.length / SIZE_OF_CELL,
          verticalNumberOfCells =
            +this.props.buildValuesSides[step - 2].height / SIZE_OF_CELL,
          innerAreaSizeOneCell = innerAreaWidth / horizontalNumberOfCells;

    this.setState({
      innerAreaSizeOneCell: innerAreaSizeOneCell,
      verticalNumberOfCells: verticalNumberOfCells,
      horizontalNumberOfCells: horizontalNumberOfCells
    });
  }
  changeInputValue = e => {
    let step = +this.props.match.params.step,
      name = e.target.dataset.inputName,
      index = +e.target.dataset.inputNumber;
    let lidObj = this.props.buildValuesSides[step - 2]
    if (e.target.dataset.inputLid) {
      let value;
      if (e.target.type === "checkbox") {
        value = {
          step: step - 2,
          lidIndex: index,
          [name]: !this.props.buildValuesSides[step - 2].lids[index][name]
        };        
      } else {
        value = {
          step: step - 2,
          lidIndex: index,
          [name]: +e.target.value
        };
      }
      let selectedlid = lidObj.lids[index] || {}
      if(name === "height" && this.props.buildValues.height >= (value.height+selectedlid.top)){
        this.props.pushBuildValueSides(value)
      } else if(name === "length" && this.props.buildValues.length >= (value.length+selectedlid.left)){
        this.props.pushBuildValueSides(value)
      }else if(name !== "height" && name !== "length"){
        this.props.pushBuildValueSides(value)
      }
    } else {
      let value;
      if (e.target.type === "checkbox") {
        value = {
          step: step - 2,
          [name]: !this.props.buildValuesSides[step - 2][name]
        };
      } else {
        value = {
          step: step - 2,
          [name]: e.target.value
        };
        if (name === "height" && +e.target.value < 1000) {
          if (
            +e.target.value < this.props.buildValues.height &&
            isAllowLids(0) &&
            isAllowSleeve()
          ) {
            this.props.pushBuildValue(value);
          } else if (+e.target.value > this.props.buildValues.height) {
            this.props.pushBuildValue(value);
          }
        }
      }
      let prevHeight = this.props.buildValues.height;
      this.props.pushBuildValueSides(value);
      value = shiftSleevesAndLids(prevHeight);
      this.props.pushBuildValueSides(value);
    }
  };

  addLid = e => {
    e.preventDefault();
    this.props.addLid({ step: +this.props.match.params.step - 2 });
  };
  deleteLid = (step, index) => {
    this.props.deleteLid(step, index);
  };
  deleteFromPlan = (step, index) => {
    this.props.deleteFromPlan(step, index);
  };

  render() {
    const currentStep = +this.props.match.params.step,
        buildValues = this.props.buildValuesSides[currentStep - 2],
        sides = ["a", "b", "c", "d"];
    return (
      <main className={"step-2"}>
        <PlanArea
          currentStep={currentStep}
          changeInputValue={this.changeInputValue}
          innerAreaSizeOneCell={this.state.innerAreaSizeOneCell}
          horizontalNumberOfCells={this.state.horizontalNumberOfCells}
          verticalNumberOfCells={this.state.verticalNumberOfCells}
        />
        <OptionsArea
          duplicateSide={this.props.duplicateSide}
          prevStep={currentStep - 1}
          nextStep={currentStep + 1}
          currentStep={currentStep}
          addLid={this.addLid}
          buildValues={buildValues}
          deleteFromPlan={this.deleteFromPlan}
          widthOfArea={this.props.buildValues.width}
          lengthOfArea={this.props.buildValues.length}
          height={this.props.buildValues.height}
          changeInputValue={this.changeInputValue}
          deleteLid={this.deleteLid}
        />
        <div className="overview-step-2">
            {sides.map((item, index) => {
                /***
                 * index + 2 because first step begin from 2 and index from 0;
                 */
                return(
                    <div
                        key={item}
                        className={`overview-side-${item} default-overview-header`}
                        style={{ color: currentStep === index + 2 ? "black" : "#ffffff" }}
                    >
                        {(() => {


                          const currentViewStyle = {
                            borderRightColor: "red"
                          };

                          switch (index) {
                            case 0:
                              return (
                                  <div>
                                    Ansicht
                                    <span className={`uppercase-default`}>{item}</span>
                                    <span
                                        className= "my-down-arrow"
                                        style={{ borderTopColor: currentStep === index + 2 ? "green" : "#ffffff" }}
                                    />
                                  </div>
                              );

                            case 1:
                              return (
                                  <div>
                                    <span
                                        className= "my-up-arrow"
                                        style={{ borderBottomColor: currentStep === index + 2 ? "green" : "#ffffff" }}
                                    />
                                    Ansicht
                                    <span className={`uppercase-default`}>{item}</span>
                                  </div>
                              );

                            case 2:
                              return (
                                  <div>
                                    <span
                                        className= "my-right-arrow"
                                        style={{ borderRightColor: currentStep === index + 2 ? "green" : "#ffffff" }}
                                    />
                                    Ansicht <span className={`uppercase-default`}>{item}</span>
                                  </div>
                              );

                            case 3:
                              return (
                                  <div>
                                    <span
                                        className= "my-right-arrow"
                                        style={{ borderRightColor: currentStep === index + 2 ? "green" : "#ffffff" }}
                                    />
                                    Ansicht <span className={`uppercase-default`}>{item}</span>
                                  </div>
                              );

                            default :
                              return null
                          }
                        })()}
                    </div>
                );
            })}
          <div className={`overview-plan overview-plan-side-${sides[currentStep - 2]}`} >
            <div className="innerPlan">
              {/*
              <VerticalArrows borderColor={"gray"} marginLeft={"20%"} />
              <HorizontalArrows borderColor={"gray"} />
            */}
            </div>
            <div className="overview-color-side" />
          </div>
        </div>
      </main>
    );
  }
}

const mapStateToProps = state => {
  return {
    buildValuesSides: state.buildValuesSides,
    buildValues: state.buildValues
  };
};

const mapStateToDispatch = {
  pushBuildValueSides,
  pushBuildValue,
  addLid,
  duplicateSide,
  deleteLid,
  deleteFromPlan
};

BuildStep.propTypes = {};

export default withRouter(
  connect(mapStateToProps, mapStateToDispatch)(BuildStep)
);



// WEBPACK FOOTER //
// ./src/containers/steps/BuildSteps/index.js